import { render, staticRenderFns } from "./weka-done.vue?vue&type=template&id=2f06b17a&lang=pug"
import script from "./weka-done.vue?vue&type=script&lang=js"
export * from "./weka-done.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports